import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
export const changePassword = createAsyncThunk(
  'user/changePassword',
  async ({ userId, oldPassword, newPassword, token }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${baseUrl}/users/change-password/${userId}`,
        { oldPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data; // The response from the server
    } catch (err) {
      const message =
        err.response?.data?.message || err.message || 'Something went wrong';
      return rejectWithValue(message);
    }
  }
);
